export const imageExtensions = ['.GIF', '.JPG', '.JPEG', '.PNG'];
export const videoExtensions = ['.MP4', '.AVI', '.WMV', '.MOV', '.3GP', '.FLV', '.MPEG-1', '.MPEG-2', '.WebM'];
